import { booleanAttribute, Component, computed, input } from '@angular/core';
import { ComponentWithSizesComponent } from '@vendasta/galaxy/utility/component-with-sizes';

export type ProgressBarColor = 'primary' | 'warn' | 'error' | 'success';

@Component({
  selector: 'glxy-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  host: {
    '[style.height.px]': 'barHeight()',
  },
})
export class GalaxyProgressBarComponent extends ComponentWithSizesComponent {
  /** Progress as a percentage, 0-100. */
  public readonly progress = input(0);

  /** Color scheme. */
  public readonly color = input<ProgressBarColor>('primary');

  /** Indicates that the progress data has not yet been loaded. */
  public readonly isLoading = input(false, { transform: booleanAttribute });

  /** Animates the fill from 0 to `progress` on first render. Opt-in; default off preserves existing behavior. */
  public readonly animateOnEnter = input(false, { transform: booleanAttribute });

  protected readonly barHeight = computed(() => {
    switch (this.size()) {
      case 'large':
        return 16;
      case 'small':
        return 8;
      default:
        return 12;
    }
  });
}
